import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/inspector-credentials';

export class InspectorCredentialsService extends RestServiceConnection {

    list = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    getById = async (inspectorCredentialsId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { inspectorCredentialsId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    create = async (data: Record<string, unknown>) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    edit = async (data: Record<string, unknown>) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    delete = async (inspectorCredentialsId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { inspectorCredentialsId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
}
